import http from './api'

const route = 'app/login/'

export default {
    logar: (login, tokencontrato) => {
        return http.post(route, {
            login: login,
            tokencontrato: tokencontrato,
        })
    },

    logout: (username, tokencontrato) => {
        return http.post(route + 'logout', {
            username: username,
            tokencontrato: tokencontrato,
        })
    },

    verificaEmpresa: (tokencontrato) => {
        return http.post(route + 'verificar_empresa', {
            tokencontrato: tokencontrato,
        })
    },

    verificaLink: (link) => {
        return http.post(route + 'verificar_link', {
            link: link,
        })
    },

    showUltimaSincronizacao: (tokencontrato) => {
        return http.post(route + 'showUltimaSincronizacao', {
            tokencontrato: tokencontrato,
        })
    },
}
